module.exports = __webpack_public_path__ + "static/media/Vector.4027edec.svg";